<div class="custom-dialog">
  <div class="top-line"></div>
  <!-- Header -->
  <div class="col-12 head-dialog d-flex justify-content-between align-items-center"
       style="padding: 12px 16px!important;">
    <span>{{ isReadOnly ? 'افزودنی‌های انتخاب شده' : 'انتخاب افزودنی' }}</span>
    <img (click)="noAction()"
         class="cursor-pointer"
         src="/icons/close-circle.svg">
  </div>
  <!-- Service Name -->
  <div class="service-name">
    {{ data.Service?.Title }}
  </div>
  <div class="content-scroll">
    <!-- Mandatory Additives Section -->
    @if (mandatoryAdditives.length > 0) {
      @for (additive of mandatoryAdditives; track additive.ServicePriceAdditiveId) {
        @if (shouldShowAdditive(additive)) {
          <div class="additive-section">
            <h3 class="section-title">{{ additive.Additive?.Title }}</h3>
            <div class="additive-options">
              @for (attribute of getSelectedAttributesForAdditive(additive); track attribute.ServicePriceAdditive?.ServicePriceAdditiveId) {
                <div (click)="!isReadOnly && onAttributeSelected(attribute, additive, $event)"
                     [class.read-only]="isReadOnly"
                     class="additive-option">
                  @if (!isReadOnly) {
                    <div (click)="$event.stopPropagation()"
                         class="option-checkbox">
                      <input
                        (change)="onAttributeSelected(attribute, additive, $event)"
                        [checked]="isAttributeSelected(attribute)"
                        [disabled]="isReadOnly"
                        [name]="'additive-' + additive.Additive?.AdditiveId"
                        class="radio-input"
                        type="radio">
                    </div>
                  }
                  <div class="option-text">
                    <span class="option-name">{{ attribute.Attribute?.AttributeTitle }}</span>
                    @if (attribute.Attribute?.AttributeDescription) {
                      <span class="option-description">{{ attribute.Attribute.AttributeDescription }}</span>
                    }
                  </div>
                  <div class="option-price">{{ formatPrice(getAttributePrice(attribute)) }}</div>
                </div>
              }
            </div>
          </div>
        }
      }
    }

    <!-- Optional Additives Section -->
    @if (optionalAdditives.length > 0) {
      @for (additive of optionalAdditives; track additive.ServicePriceAdditiveId) {
        @if (shouldShowAdditive(additive)) {
          <div class="additive-section">
            <h3 class="section-title">{{ additive.Additive?.Title }}</h3>
            <div class="additive-options">
              @for (attribute of getSelectedAttributesForAdditive(additive); track attribute.ServicePriceAdditive?.ServicePriceAdditiveId) {
                <div (click)="!isReadOnly && onAttributeSelected(attribute, additive, $event)"
                     [class.read-only]="isReadOnly"
                     class="additive-option">
                  @if (!isReadOnly) {
                    <div (click)="$event.stopPropagation()"
                         class="option-checkbox">
                      <div class="checkbox-container">
                        <input
                          (change)="onAttributeSelected(attribute, additive, $event)"
                          [checked]="isAttributeSelected(attribute)"
                          [disabled]="isReadOnly"
                          class="checkbox-input"
                          type="checkbox">
                        <span class="checkbox-custom"></span>
                      </div>
                    </div>
                  }
                  <div class="option-text">
                  <span class="option-name">
                    {{ attribute.Attribute?.AttributeTitle }}
                    <span class="optional-badge">(اضافه)</span>
                  </span>
                    @if (attribute.Attribute?.AttributeDescription) {
                      <span class="option-description">{{ attribute.Attribute.AttributeDescription }}</span>
                    }
                  </div>
                  <div class="option-price">{{ formatPrice(getAttributePrice(attribute)) }}</div>
                </div>
              }
            </div>
          </div>
        }
      }
    }
  </div>
  <!-- Submit Button -->
  @if (!isReadOnly) {
    <div class="col-12 d-flex justify-content-center align-items-center res-btn mt-5">
      <button
        (click)="onSubmit()"
        [disabled]="!canSubmit()"
        class="submit-button">
        افزودن به سبد خرید {{ formattedTotalPrice }}
      </button>
    </div>
  }
</div>

